import parseError from '@/lib/errors/parseError'

export const responseOnError = error => {
  if (error.message === 'Network Error') {
    return Promise.reject({
      response: {
        data: {
          code: 'networkError',
          message: 'Falha na conexão',
        },
      },
    })
  }
  return Promise.reject(parseError(error))
}
